module.exports = __webpack_public_path__ + "static/media/background.4c1d629b.png";